import http from './http';

export default {
  // 获取科目列表
  getList(params) {
    return http.get('/o1/Subject/index', params);
  },

  // 获取科目树形结构
  getTree(params) {
    return http.get('/o1/Subject/tree', params);
  },

  // 获取科目详情
  getDetail(id) {
    return http.get('/o1/Subject/read', { id });
  },

  // 创建科目
  create(data) {
    return http.post('/o1/Subject/save', data);
  },

  // 更新科目
  update(data) {
    return http.post('/o1/Subject/save', data); // 使用save接口，有ID则更新
  },

  // 删除科目
  delete(id) {
    return http.post('/o1/Subject/delete', { id });
  },

  // 以下是保留的原有方法，可能在其他地方使用
  getSubjectList(params) {
    return this.getList(params);
  },
  
  getSubjectDetail(subjectId) {
    return this.getDetail(subjectId);
  },
  
  createSubject(data) {
    return this.create(data);
  },
  
  updateSubject(subjectId, data) {
    return this.update({ id: subjectId, ...data });
  },
  
  deleteSubject(subjectId) {
    return this.delete(subjectId);
  },
  
  // 启用/禁用科目
  toggleSubjectStatus(subjectId, status) {
    return this.update({ id: subjectId, status });
  },
  
  // 批量导入科目
  importSubjects(file) {
    const formData = new FormData();
    formData.append('file', file);
    return http.upload('/o1/Subject/import', formData);
  },
  
  // 导出科目
  exportSubjects(params = {}) {
    return http.post('/o1/Subject/export', params, {
      responseType: 'blob'
    });
  },
  
  // 获取科目统计
  getSubjectStatistics() {
    return http.get('/o1/Subject/statistics');
  },
  
  // 批量更新科目排序
  updateSubjectsOrder(data) {
    return http.post('/o1/Subject/updateOrder', data);
  }
};